import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanKTAFinancial1Service from "services/Setup/LoanOrigination/Financial/ApkLoanKTAFinancial1Service";
import { notification } from "antd";
import editData from "assets/data/sempelresponeditkkb/finacial1.json"

export const initialState = {
  loading: false,
  loadingFinancial1: false,
  loadingConvertEffectiveToFlat: false,
  loadingConvertFlatToEffective: false,
  loadingTotalInterest: false,
  loadingMonthlyInstallment: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  flatToEffective: [],
  effectiveToFlat: [],
  InsuranceComBranchList: [],
  getApkLoanKTAFinancial1: [],
  getEditApkLoanKTAFinancial1: [],
  // getEditApkLoanKTAFinancial1: editData.data,
  totalInterest: {},
  monthlyInstallment: "",
  simulateWithInstallment: [],
  flatInterestFromInstallment: [],
  apkLoanKTAFinancial1: [],
  apkLoanKKBFinancial1: [],
  calculateFinancial1: {},
  simulateFinancial1: [],
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const convertFlatToEffective = createAsyncThunk(
  "ApkLoanKTAFinancial1/convertFlatToEffective",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKTAFinancial1Service.convertFlatToEffective(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const convertEffectiveToFlat = createAsyncThunk(
  "ApkLoanKTAFinancial1/convertEffectiveToFlat",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ convertEffectiveToFlat ~ userInput", userInput);

    try {
      const response = await ApkLoanKTAFinancial1Service.convertEffectiveToFlat(
        userInput
      );
      console.log("🚀 ~ convertEffectiveToFlat ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const totalInterestSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/totalInterestSlice",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ totalInterestSlice ~ userInput", userInput);

    try {
      const response = await ApkLoanKTAFinancial1Service.totalInterestService(
        userInput
      );
      // console.log("🚀 ~ totalInterest ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const monthlyInstallmentSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/monthlyInstallmentSlice",
  async (userInput, { rejectWithValue }) => {
    // console.log("🚀 ~ monthlyInstallmentSlice ~ userInput", userInput);

    try {
      const response =
        await ApkLoanKTAFinancial1Service.monthlyInstallmentService(userInput);
      // console.log("🚀 ~ monthlyInstallmentSlice ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const simulateSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/simulateSlice",
  async (userInput, { rejectWithValue }) => {
    // console.log("🚀 ~ simulateSlice ~ userInput", userInput);

    try {
      const response = await ApkLoanKTAFinancial1Service.simulateService(
        userInput
      );
      // console.log("🚀 ~ simulateSlice ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApkLoanKTAFinancial1Slice = createAsyncThunk(
  "ApkLoanKTAFinancial1/getApkLoanKTAFinancial1Slice",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getApkLoanKTAFinancial1Slice ~ userInput", userInput);
    try {
      const response =
        await ApkLoanKTAFinancial1Service.getApkLoanKTAFinancial1Service(
          userInput
        );
      console.log("🚀 ~ getApkLoanKTAFinancial1Slice ~ response", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getEditApkLoanKTAFinancial1Slice = createAsyncThunk(
  "ApkLoanKTAFinancial1/getEditApkLoanKTAFinancial1Slice",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getEditApkLoanKTAFinancial1Slice ~ userInput", userInput);
    try {
      const response =
        await ApkLoanKTAFinancial1Service.getEditApkLoanKTAFinancial1Service(
          userInput
        ); 

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postApkLoanKTAFinancial1Slice = createAsyncThunk(
  "ApkLoanKTAFinancial1/postApkLoanKTAFinancial1Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial1Service.postApkLoanKTAFinancial1Service(
          userInput
        );
      // console.log("responsepostApkLoanKTAFinancial1Service", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanKTAFinancial1Slice = createAsyncThunk(
  "ApkLoanKTAFinancial1/putApkLoanKTAFinancial1Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial1Service.putApkLoanKTAFinancial1Service(
          userInput
        );
      console.log("responseputApkLoanKTAFinancial1Service", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getflatInterestFromInstallment = createAsyncThunk(
  "ApkLoanKTAFinancial1/getflatInterestFromInstallment",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial1Service.getflatInterestFromInstallment(data);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAddApkLoanKKBFinancial1Slice = createAsyncThunk(
  "ApkLoanKTAFinancial1/getAddApkLoanKKBFinancial1Slice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial1Service.getAddApkLoanKKBFinancial1Service(
          data
        );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCalculateSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/posCalculateSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKTAFinancial1Service.posCalculateService(
        userInput
      );
      // console.log("responsepostApkLoanKTAFinancial1Service", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        //Selain Response 200
        // console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posSimulateSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/posSimulateSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanKTAFinancial1Service.posSimulateService(
        userInput
      );
      // console.log("responsepostApkLoanKTAFinancial1Service", response);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        //Selain Response 200
        // console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posAddFinancial1KKBSlice = createAsyncThunk(
  "ApkLoanKTAFinancial1/posAddFinancial1KKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApkLoanKTAFinancial1Service.posAddFinancial1KKBService(
          userInput
        );
      // console.log("responsepostApkLoanKTAFinancial1Service", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ApkLoanKTAFinancial1Slice = createSlice({
  name: "apkLoanKTAFinancial1",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },

    resetDataFinancial1: (state) => {
      state.getApkLoanKTAFinancial1 = [];
      state.getEditApkLoanKTAFinancial1 = [];
      state.totalInterest = {};
      state.monthlyInstallment = "";
      state.simulateWithInstallment = [];
      state.flatInterestFromInstallment = [];
    },

    tesgetEditApkLoanKTAFinancial1: (state, action) => {
      state.getEditApkLoanKTAFinancial1 = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder

      //list
      .addCase(convertFlatToEffective.pending, (state) => {
        state.loadingConvertFlatToEffective = true;
        state.redirect = "";
      })
      .addCase(convertFlatToEffective.fulfilled, (state, action) => {
        state.loadingConvertFlatToEffective = false;
        state.flatToEffective = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(convertFlatToEffective.rejected, (state, action) => {
        state.loadingConvertFlatToEffective = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // convertEffectiveToFlat
      .addCase(convertEffectiveToFlat.pending, (state) => {
        state.loadingConvertEffectiveToFlat = true;
        state.redirect = "";
      })
      .addCase(convertEffectiveToFlat.fulfilled, (state, action) => {
        // console.log("🚀 ~ convertEffectiveToFlat ~ action", action);

        state.loadingConvertEffectiveToFlat = false;
        state.effectiveToFlat = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(convertEffectiveToFlat.rejected, (state, action) => {
        state.loadingConvertEffectiveToFlat = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // totalInterest
      .addCase(totalInterestSlice.pending, (state) => {
        state.loadingTotalInterest = true;
        state.redirect = "";
      })
      .addCase(totalInterestSlice.fulfilled, (state, action) => {
        state.loadingTotalInterest = false;
        state.totalInterest = action?.payload?.totalInterest;
      })
      .addCase(totalInterestSlice.rejected, (state, action) => {
        state.loadingTotalInterest = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // monthlyInstallmentSlice
      .addCase(monthlyInstallmentSlice.pending, (state) => {
        state.loadingMonthlyInstallment = true;
        state.redirect = "";
      })
      .addCase(monthlyInstallmentSlice.fulfilled, (state, action) => {
        state.loadingMonthlyInstallment = false;
        state.monthlyInstallment = action?.payload?.monthlyInstallment;
      })
      .addCase(monthlyInstallmentSlice.rejected, (state, action) => {
        state.loadingMonthlyInstallment = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // monthlyInstallmentSlice
      .addCase(simulateSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(simulateSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.simulateWithInstallment = action?.payload;
      })
      .addCase(simulateSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getApkLoanKTAFinancial1Slice
      .addCase(getApkLoanKTAFinancial1Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApkLoanKTAFinancial1Slice.fulfilled, (state, action) => {
        console.log("🚀 ~ getApkLoanKTAFinancial1Slice ~ action", action);

        state.loading = false;
        state.getApkLoanKTAFinancial1 = action?.payload?.data;
      })
      .addCase(getApkLoanKTAFinancial1Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getEditApkLoanKTAFinancial1Slice
      .addCase(getEditApkLoanKTAFinancial1Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEditApkLoanKTAFinancial1Slice.fulfilled, (state, action) => { 

        state.loading = false;
        state.getEditApkLoanKTAFinancial1 = action?.payload?.data;
      })
      .addCase(getEditApkLoanKTAFinancial1Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   pos
      .addCase(postApkLoanKTAFinancial1Slice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(postApkLoanKTAFinancial1Slice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingFinancial1 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(postApkLoanKTAFinancial1Slice.rejected, (state, action) => {
        state.loadingFinancial1 = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   put
      .addCase(putApkLoanKTAFinancial1Slice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(putApkLoanKTAFinancial1Slice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingFinancial1 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(putApkLoanKTAFinancial1Slice.rejected, (state, action) => {
        state.loadingFinancial1 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   getflatInterestFromInstallment
      .addCase(getflatInterestFromInstallment.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(getflatInterestFromInstallment.fulfilled, (state, action) => {
        // console.log("flatInterestFromInstallment1234:", "masuk");

        state.loadingFinancial1 = false;
        state.flatInterestFromInstallment = action?.payload;
      })
      .addCase(getflatInterestFromInstallment.rejected, (state, action) => {
        state.loadingFinancial1 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   getAddApkLoanKKBFinancial1Slice
      .addCase(getAddApkLoanKKBFinancial1Slice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(getAddApkLoanKKBFinancial1Slice.fulfilled, (state, action) => {
        console.log("getAddApkLoanKKBFinancial1Slice", action);

        state.loadingFinancial1 = false;
        state.apkLoanKKBFinancial1 = action?.payload;
      })
      .addCase(getAddApkLoanKKBFinancial1Slice.rejected, (state, action) => {
        state.loadingFinancial1 = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   posCalculateSlice
      .addCase(posCalculateSlice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(posCalculateSlice.fulfilled, (state, action) => {
        state.loadingFinancial1 = false;
        state.redirect = "/";
        state.calculateFinancial1 = action?.payload;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posCalculateSlice.rejected, (state, action) => {
        state.calculateFinancial1 = {};
        state.showMessage = true;
      })

      //   posCalculateSlice
      .addCase(posSimulateSlice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(posSimulateSlice.fulfilled, (state, action) => {
        state.loadingFinancial1 = false;
        state.redirect = "/";
        state.simulateFinancial1 = action?.payload;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posSimulateSlice.rejected, (state, action) => {
        state.simulateFinancial1 = {};
        state.showMessage = true;
      })
      //   posAddFinancial1KKBSlice
      .addCase(posAddFinancial1KKBSlice.pending, (state) => {
        state.loadingFinancial1 = true;
      })
      .addCase(posAddFinancial1KKBSlice.fulfilled, (state, action) => {
        state.loadingFinancial1 = false;
        state.redirect = "/";
        // state.simulateFinancial1 = action?.payload;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posAddFinancial1KKBSlice.rejected, (state, action) => {
        // state.simulateFinancial1 = {};
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  resetDataFinancial1,
  tesgetEditApkLoanKTAFinancial1,
} = ApkLoanKTAFinancial1Slice.actions;

export default ApkLoanKTAFinancial1Slice.reducer;
